module.exports = __webpack_public_path__ + "img/world_vision_icon3.21741473.svg";